import { OrderModel } from "../core/_models/order.model";

const QR_TABLE_KEY = 'qr_table_id';

export function getJsonLocalStorage(key: string): any {
    let dataString = localStorage.getItem(key)
    if (dataString) {
        return JSON.parse(dataString)
    }
    return null
}

export function setJsonLocalStorage(key: string, data: any): any {
  return localStorage.setItem(key, JSON.stringify(data))
}

export function removeUndefinedValues(obj: any) {
  for (let key in obj) { 
    if (obj[key] === undefined) { 
      delete obj[key]; 
    } else if (typeof obj[key] === 'object') {
      removeUndefinedValues(obj[key]); 
    } 
  } 
  return obj; 
}

export function saveOderLocalStorage(order: OrderModel): any {
    const orderStorage: OrderModel[] = JSON.parse(localStorage.getItem("order_data") || "[]");
    const updatedOrders = orderStorage.map((orderMap: any) =>
        orderMap.order_id === order.store_id ? { ...orderMap, ...order } : orderMap
    );
    if (!updatedOrders.find((orderMap) => orderMap.order_id === order.store_id)) {
        updatedOrders.push({ order_id: order.store_id, ...order });
    }
    localStorage.setItem("order_data", JSON.stringify(updatedOrders));
}

export function getOrderLocalStorage(orderDataId: string): any {
    const orderStorage: OrderModel[] = JSON.parse(localStorage.getItem("order_data") || "[]");
    const foundOrder = orderStorage.find((order: any) => order.order_id === orderDataId);
    return foundOrder || null;
}

export function removeOrderLocalStorage(orderID: string): void {
    const orderStorage: any[] = JSON.parse(localStorage.getItem("order_data") || "[]");
    const updatedOrders = orderStorage.filter(order => order.order_id !== orderID);
    localStorage.setItem("order_data", JSON.stringify(updatedOrders));
    sessionStorage.removeItem(QR_TABLE_KEY);
}

export function saveQrTableLocalStorage(tableId: string): void {
    if (!tableId || typeof tableId !== 'string') return;
    const sanitized = tableId.trim();
    if (sanitized.length > 0 && sanitized.length <= 100) {
        sessionStorage.setItem(QR_TABLE_KEY, sanitized);
    }
}

export function getQrTableLocalStorage(): string | null {
    return sessionStorage.getItem(QR_TABLE_KEY);
}

export function clearQrTableLocalStorage(): void {
    sessionStorage.removeItem(QR_TABLE_KEY);
}
